import { Component, OnInit, Input } from '@angular/core';

@Component({
	selector: 'ras-image-banner',
	templateUrl: './image-banner.component.html',
	styleUrls: ['./image-banner.component.sass']
})
export class ImageBannerComponent implements OnInit {

	@Input() image: string;
	@Input() imageWebp: string;
	@Input() position: string = 'center';
	@Input() text: string;
	@Input() topText: string;
	@Input() topText2: string;
	@Input() mainText: string;
	@Input() focusX: string;
	@Input() focusY: string;

	constructor() { }

	ngOnInit(): void {
	}

}
